<div class="px-3">
    <h5 *ngIf="modelList" style="margin-bottom: 20px; font-weight:bold; color: black;">Bollettino Meteo emesso il {{
        modelList.dataEmissione }}</h5>

    <h5 *ngIf="!modelList" style="margin-bottom: 20px; color: #00000080;">Siamo spiacenti, non ci sono previsioni meteo
        disponibili</h5>

    <div class="card">
        <div class="card-header background-card-header">ESAME SINOTTICO</div>
        <div class="card-body" style="min-height: 50px;">
            <span class="testi">{{ modelList && modelList.esameSinottico ? modelList.esameSinottico : "" }}</span>
        </div>
    </div>
    <div class="nav-tabs-navigation card" data-tabs-color="orange">
        <div class="nav-tabs-wrapper nb-theme-default">
            <nb-tabset>
                <nb-tab tabTitle="OGGI" style="overflow:hidden">
                    <div class="row w-100 justify-content-center px-3 py-2">
                        <div class="col-md-4 col-xs-12 col-sm-12 d-flex flex-column align-items-center svg-map"
                            style="float: left;">
                            <h5 class="titolo-giorno">Mattina</h5>
                            <canvas id="canvas" #canvasElem>
                                Spiacenti, immagine non disponibile
                            </canvas>
                        </div>
                        <div class="col-md-4 col-xs-12 col-sm-12 d-flex flex-column align-items-center svg-map"
                            style="float: left;">
                            <h5 class="titolo-giorno">Pomeriggio</h5>
                            <canvas id="canvasPome" #canvasElemPome>
                                Spiacenti, immagine non disponibile
                            </canvas>
                        </div>
                        <div class="col-md-4 col-xs-12 col-sm-12 d-flex flex-column align-items-center svg-map"
                            style="float: left;">
                            <h5 class="titolo-giorno">Sera/Notte</h5>
                            <canvas id="canvasSera" #canvasElemSera>
                                Spiacenti, immagine non disponibile
                            </canvas>
                        </div>
                    </div>
                    <div *ngIf="modelList" class="d-flex flex-column pt-3">
                        <div class="d-flex justify-content-center">
                            <span class="esame-testo">{{ previsioniPerGiornoList[0].descGenerale }}</span>
                        </div>
                        <!-- Card zone -->
                        <div class="d-flex justify-content-center titolo-card-zone">Stato del cielo e precipitazioni</div>
                        <div class="card-zone-container d-flex flex-wrap justify-content-center">
                            <div class="col-md-3 col-sm-12 card-zone-meteo w-100"
                                *ngFor="let elementK of previsioniPerGiornoList[0].meteoPerZona; let k = index;">
                                <div class="card-zone-meteo-body">
                                    <div class="header-zona">
                                        <span class="numero-zona">ZONA {{ elementK.zona }}</span>
                                    </div>
                                    <div class="body-zona">
                                        <div class="d-flex align-items-center w-100 border-bottom px-3 py-1">
                                            <span style="font-size: 12px; font-style: italic;opacity: 0.9;">
                                                {{getIndByZona(elementK.zona)}}
                                            </span>
                                            <hr>
                                        </div>
                                        <div class="w-100 p-3">
                                            {{ elementK.previsione }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </nb-tab>

                <nb-tab tabTitle="DOMANI" style="overflow:hidden">
                    <!-- <h5 *ngIf="modelList" style="color:#00000080; font-weight:bold; margin-top:20px;">
                                        Previsioni per {{ giornoArray[tomorrow] }} {{ previsioniPerGiornoList[1].dataRiferimento }}
                                    </h5> -->
                    <div class="row w-100 justify-content-center px-3 py-2">
                        <div class="col-md-4 col-xs-12 col-sm-12 d-flex flex-column align-items-center svg-map"
                            style="float: left;">
                            <h5 class="titolo-giorno">Mattina</h5>
                            <canvas id="canvasDomani" #canvasElemDomani>
                                Spiacenti, immagine non disponibile
                            </canvas>
                        </div>
                        <div class="col-md-4 col-xs-12 col-sm-12 d-flex flex-column align-items-center svg-map"
                            style="float: left;">
                            <h5 class="titolo-giorno">Pomeriggio</h5>
                            <canvas id="canvasDomaniPome" #canvasElemDomaniPome>
                                Spiacenti, immagine non disponibile
                            </canvas>
                        </div>
                        <div class="col-md-4 col-xs-12 col-sm-12 d-flex flex-column align-items-center svg-map"
                            style="float: left;">
                            <h5 class="titolo-giorno">Sera/Notte</h5>
                            <canvas id="canvasDomaniSera" #canvasElemDomaniSera>
                                Spiacenti, immagine non disponibile
                            </canvas>
                        </div>
                    </div>
                    <div *ngIf="modelList" class="d-flex flex-column pt-3">
                        <!-- Descrizione -->
                        <div class="col-md-12"
                            style="margin-bottom: 30px; text-align: justify; text-justify: inter-word;">
                            <span class="esame-testo">{{ previsioniPerGiornoList[1].descGenerale }}</span>
                        </div>
                        <!-- Card zone -->
                        <div class="d-flex justify-content-center titolo-card-zone">Stato del cielo e precipitazioni
                        </div>
                        <div class="card-zone-container d-flex flex-wrap justify-content-center">
                            <div class="col-md-3 col-sm-12 card-zone-meteo w-100"
                                *ngFor="let elementK of previsioniPerGiornoList[1].meteoPerZona; let k = index;">
                                <div class="card-zone-meteo-body">
                                    <div class="header-zona">
                                        <span class="numero-zona">ZONA {{ elementK.zona }}</span>
                                    </div>
                                    <div class="body-zona">
                                        <div class="d-flex align-items-center w-100 border-bottom px-3 py-1">
                                            <span style="font-size: 12px; font-style: italic;opacity: 0.9;">
                                                {{getIndByZona(elementK.zona)}}
                                            </span>
                                            <hr>
                                        </div>
                                        <div class="w-100 p-3">
                                            {{ elementK.previsione }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </nb-tab>
                <nb-tab tabTitle="DOPODOMANI" style="overflow:hidden">
                    <!--  <h5 *ngIf="modelList" style="color:#00000080; font-weight:bold; margin-top:20px;">
                                        Previsioni per {{ giornoArray[dayaftertomorrow] }} {{ previsioniPerGiornoList[2].dataRiferimento }}
                                    </h5> -->
                    <div class="row w-100 justify-content-center px-3 py-2">
                        <div class="col-md-4 col-xs-12 col-sm-12 d-flex flex-column align-items-center svg-map"
                            style="float: left;">
                            <h5 class="titolo-giorno">Mattina</h5>
                            <canvas id="canvasDopodomani" #canvasElemDopodomani>
                                Spiacenti, immagine non disponibile
                            </canvas>
                        </div>
                        <div class="col-md-4 col-xs-12 col-sm-12 d-flex flex-column align-items-center svg-map"
                            style="float: left;">
                            <h5 class="titolo-giorno">Pomeriggio</h5>
                            <canvas id="canvasDopodomaniPome" #canvasElemDopodomaniPome>
                                Spiacenti, immagine non disponibile
                            </canvas>
                        </div>
                        <div class="col-md-4 col-xs-12 col-sm-12 d-flex flex-column align-items-center svg-map"
                            style="float: left;">
                            <h5 class="titolo-giorno">Sera/Notte</h5>
                            <canvas id="canvasDopodomaniSera" #canvasElemDopodomaniSera>
                                Spiacenti, immagine non disponibile
                            </canvas>
                        </div>
                    </div>
                    <div *ngIf="modelList" class="d-flex flex-column pt-3">
                        <!-- Descrizione -->
                        <div class="col-md-12"
                            style="margin-bottom: 30px; text-align: justify; text-justify: inter-word;">
                            <span class="esame-testo">{{ previsioniPerGiornoList[2].descGenerale }}</span>
                        </div>
                        <!-- Card zone -->

                        <div class="d-flex justify-content-center titolo-card-zone">Stato del cielo e precipitazioni
                        </div>
                        <div class="card-zone-container d-flex flex-wrap justify-content-center">
                            <div class="col-md-3 col-sm-12 card-zone-meteo w-100"
                                *ngFor="let elementK of previsioniPerGiornoList[2].meteoPerZona; let k = index;">
                                <div class="card-zone-meteo-body">
                                    <div class="header-zona">
                                        <span class="numero-zona">ZONA {{ elementK.zona }}</span>
                                    </div>
                                    <div class="body-zona">
                                        <div class="d-flex align-items-center w-100 border-bottom px-3 py-1">
                                            <span style="font-size: 12px; font-style: italic;opacity: 0.9;">
                                                {{getIndByZona(elementK.zona)}}
                                            </span>
                                            <hr>
                                        </div>
                                        <div class="w-100 p-3">
                                            {{ elementK.previsione }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </nb-tab>
            </nb-tabset>
        </div>
    </div>
</div>